/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum FormNames {
    ColorScheme = 'ColorScheme',
    PortalWebAddress = 'PortalWebAddress',
    PortalName = 'PortalName',
}
